import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import { useStyles } from "../../styles";
import { useTranslation } from "react-i18next";
import { CustomPaper } from "../../../../../../../../../../components/CustomPaper";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { icons } from "../../../../../../../../../../utils/icons";
import { useEvidences } from "../../../../../../../../../../hooks/evidences/useEvidences";
import EvidenceDetail from "../../../../../../../../../actionPlans/pages/form/components/evidenceDetail";
import { VIEW_TYPES } from "../../../../types/ViewTypes";
import { SnackSimple } from "../../../../../../../../../../components";
import { Types } from "../../../../../../../../../../utils/enums/types";
import { ActionDrawer } from "../../../../../../../../../../components/ActionDrawer";
import { useEvidenceDownload } from "../../../../../../../../../calendar/pages/detail/hooks";
import { AnswerTypeHistory } from "../../../../enums/answerType";
import { Constants } from "../../../../../../../../../../utils/constants";

export const WaitingSolution = ({ items, onAttend, disabled }) => {
  const styles = useStyles();
  const { t } = useTranslation();
  //const { isDownloading, error, downloadEvidences } = useDownloadEvidences();
  const { id: reportFolioId } = useParams();
  const [isModalOpen, setModalOpen] = useState(false);
  const lastQuote = items?.filter((item) => item.type === AnswerTypeHistory.WAITING).at(-1);
  const reasonOfRejectionQuote = lastQuote?.reasonOfRejectionQuote
  const reasonOfApproveQuote = lastQuote?.commentApprovalQuote
  const { evidences, existEvidences } = useEvidences({
    evidencesResponse: lastQuote?.evidencesQuote,
    manualValue: false,
  });

  const { disable:isDownloading, /* openSnackbar, handleCloseSnackbar, */ downloadEvidences, } = useEvidenceDownload('evidencias', lastQuote?.evidencesQuote );

  const [downloadSnack, setDownloadSnack] = useState({
    open: false,
    message: ""
  });

  const provider = lastQuote?.usersAssings?.[0]
    ? `${lastQuote.usersAssings[0].firstName} ${lastQuote.usersAssings[0].lastName}`
    : t("reportFolio.detail.general.noAssignedUser");

  const formattedDate = lastQuote?.dateRequestQuote
    ? format(new Date(lastQuote.dateRequestQuote), Constants.dateFormatGeneral3, { locale: es })
    : t("reportFolio.detail.general.noDateAvailable");

  const formatDateRequest = lastQuote?.dateRequestManagement
    ? format(new Date(lastQuote.dateRequestManagement), Constants.dateFormatGeneral3, { locale: es })
    : t("reportFolio.detail.general.noDateAvailable");

  const handleAttend = () => {
    onAttend();
    setModalOpen(true);
  };

  const handleDownloadQuoteZip = async () => {
    setDownloadSnack({
      open: true,
      message: "Descargando evidencias..."
    });
    try {
      await downloadEvidences(lastQuote?.evidencesQuote, "evidences.zip");
    } catch (error) {
      console.error("Error downloading evidences:", error);
      setDownloadSnack({
        open: true,
        message: t("reportFolio.detail.general.oppsError")
      });
    } finally {
      setTimeout(() => {
        setDownloadSnack({
          open: false,
          message: ""
        });
      }, 3000);
    }
  };

  return (
    <>
      <CustomPaper sx={styles.userContainer} elevation={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Box >
              {reasonOfRejectionQuote ? (
                <Box display="flex" alignItems="center">
                  <Typography sx={styles.title(3)}>
                    {icons("cancel")}
                  </Typography>
                  <Typography style={{ marginLeft: '8px' }} sx={styles.title(3)}>
                    {t("reportFolio.detail.general.quotationTitleProviderSendCancel")}
                  </Typography>
                </Box>
              ) : reasonOfApproveQuote ? (
                <Box display="flex" alignItems="center">
                  <Typography sx={styles.title(4)}>
                    {icons("check")}
                  </Typography>
                  <Typography style={{ marginLeft: '8px' }} sx={styles.title(4)}>
                    {t("reportFolio.detail.general.quotationTitleProviderSendApprove")}
                  </Typography>
                </Box>
              ) : (
                <Typography sx={styles.title(2)}>
                  {t("reportFolio.detail.general.solutionTitleProvider")}
                </Typography>
              )}

            </Box>
            {reasonOfRejectionQuote ? (
              <Typography variant="body2">
                {t("reportFolio.detail.general.providerAssignedAndDateAndReject", { Date: formattedDate, Rechazada: formatDateRequest })}
              </Typography>
            ) : reasonOfApproveQuote ? (
              <Typography variant="body2">
                {t("reportFolio.detail.general.providerAssignedAndDateAndApprove", { Date: formattedDate, Rechazada: formatDateRequest })}
              </Typography>
            ) : (
              <Typography variant="body2">
                {t("reportFolio.detail.general.providerAssignedAndDate", { Date: formattedDate })}
              </Typography>
            )
            }
          </Box>

          {reasonOfRejectionQuote || reasonOfApproveQuote ? (
            <>
            </>
          ) :
            <Box display="flex" gap={2}>
              <Button variant="contained" onClick={handleAttend} disabled={disabled}>
                {t("reportFolio.detail.general.AttendquotationTitle")}
              </Button>
            </Box>
          }
        </Box >
        {reasonOfRejectionQuote ? (
          <Typography variant="body1">
            {reasonOfRejectionQuote}
          </Typography>
        ) : reasonOfApproveQuote ? (
          <Typography variant="body1">
            {reasonOfApproveQuote}
          </Typography>
        ) : (
          <></>
        )}
        {reasonOfRejectionQuote || reasonOfApproveQuote ? (
          <Box display="flex" justifyContent="end" gap={3} alignContent={"center"}>
            <ActionDrawer
              title="EVIDENCIAS"
              body={<>
                <Box sx={styles.mainContainer}>
                  <Box sx={styles.bodyContainer}>
                    <EvidenceDetail
                      existEvidences={existEvidences}
                      evidences={{
                        image: evidences?.images,
                        comment: evidences?.comments,
                        documents: evidences?.documents,
                        video: evidences?.video,
                        sign: evidences?.sign
                      }}
                    />
                  </Box>
                  <Box>
                    <Button variant='text_primary_small' onClick={downloadEvidences} disabled={isDownloading}>{t('schedule.buttons.downloadEvidence')}</Button>
                  </Box>
                </Box>
              </>}
            >
              {
                ({ openDrawer }) =>
                  <Tooltip title={t("ToolTips.seeEvidences")}>
                    <IconButton
                      onClick={() => { openDrawer() }}
                      sx={styles.clip}
                      disabled={!existEvidences}
                    >
                      {icons("clip")}
                    </IconButton>
                  </Tooltip>
              }
            </ActionDrawer>

            <Button variant="outlined" color="primary" onClick={() => onAttend(VIEW_TYPES.DETAIL_QUOTE)}>
              {t("reportFolio.detail.general.seeDetailQuote")}
            </Button>
            <Button variant="outlined" color="primary" onClick={handleDownloadQuoteZip}>
              {t("reportFolio.detail.general.dowloadQuote")}
              <Box ml={1} mt={1}>{icons("download")}</Box>
            </Button>
          </Box>
        ) : (
          <>
          </>
        )}
      </CustomPaper >

      <SnackSimple
        open={downloadSnack.open}
        close={() => setDownloadSnack({ open: false, message: "" })}
        message={downloadSnack.message}
        type={Types.INFO}
      />
    </>
  );
};
